<script>
import Loading from '../../components/loading.vue';
import MineOption from '../../components/select/mineOption.vue';
import MineSelect from '../../components/select/mineSelect.vue';

export default {
    name: "invoice",
    data() {
        return {
            tabs: [
                { text: '已开具发票', value: '' },
                { text: '申请中发票', value: '' },
                { text: '未申请', value: '' },
            ],
            activeIndex: 0,
            isLoading: false,
            list: [
                {
                    image: '',
                    time: '2025-06-26',
                    order_code: '1234567899874562',
                    name: '金满勇限量联名手机壳',
                    count: 1,
                    price: '45.00',
                    isShowLogistics: false,
                },
            ],
            // 列表弹窗
            isShowInvoiceList: false,
            // isCheckAll: false,
            // isHideDelete: true,
            invoiceList: [
                {
                    id: 1,
                    title: '上海速珮广告有限公司',
                    title_type: 1,
                    type: 1,
                    tax_code: '',
                    bank_name: '',
                    bank_code: '',
                    address: '',
                    phone: '',
                    is_default: 1,
                    isChecked: false,
                },
                {
                    id: 2,
                    title: '上海速珮广告有限公司',
                    title_type: 2,
                    type: 2,
                    tax_code: '',
                    bank_name: '',
                    bank_code: '',
                    address: '',
                    phone: '',
                    is_default: 0,
                    isChecked: false,
                },
            ],
            // 详情弹窗
            isShowInvoiceDetail: false,
            isEditInvoice: false,
            detail: {
                title: '',
                title_type: 2,
                type: 1,
                tax_code: '',
                bank_name: '',
                bank_code: '',
                address: '',
                phone: '',
                is_default: 0,
            },
            type: [
                { text: '普通发票', value: '1' },
                { text: '专用发票', value: '2' },
            ],
        };
    },
    computed: {
        // 详情 发票类型 值
        typeValue() {
            return this.type.filter((v) => v.value == this.detail.type)[0].text;
        },
        // 删除按钮是否禁用
        isHideDelete() { 
            return this.invoiceList.findIndex(v => v.isChecked) == -1;
        },
        // 发票列表是否全选
        isCheckAll() { 
            return this.invoiceList.length == this.invoiceList.filter(v => v.isChecked).length;
        },
    },
    components: {
        Loading,
        MineSelect,
        MineOption,
    },
    mounted() {},
    destroyed() {},
    watch: {
        isShowInvoiceList: {
            handler: 'popupHandler',
            immediate: true
        },
    },
    methods: {
        // 弹窗显示/隐藏监听
        popupHandler(val) { 
            if(val){
                document.body.style.overflow = 'hidden';
            }else{
                document.body.style.overflow = 'auto';
            }
        },
        // 全选
        checkAll() { 
            this.invoiceList = this.invoiceList.map(v => {
                return {
                    ...v,
                    isChecked: !this.isCheckAll
                }
            })
        },
        // 发票详情，类型选中
        // typeChoose(value){ 
        //     this.detail.type = value;
        // },
        // 新建发票
        createInvoice() { 
            this.isShowInvoiceDetail = true;
            this.detail = {
                title: '',
                title_type: 1,
                type: 1,
                tax_code: '',
                bank_name: '',
                bank_code: '',
                address: '',
                phone: '',
                is_default: 0,
            }
        },
        // 编辑发票
        editInvoice(data) { 
            this.isShowInvoiceDetail = true;
            this.detail = { ...data };
        },
    },
};
</script>

<template>
    <div class="invoice">
        <p class="title">我的发票</p>
        <div class="tabs">
            <div class="item" 
            v-for="(item, index) in tabs" :key="index" 
            :class="{active: activeIndex == index}"
            @click="activeIndex = index">{{ item.text }}</div>
        </div>
        <div class="loading_wrap" v-if="isLoading">
            <Loading/>
        </div>
        <p class="no_more" v-else-if="list.length == 0">你还没有选购商品<router-link to="/shop">立即去购物&gt;&gt;</router-link></p>
        <div class="order_list" v-else>
            <template v-if="activeIndex == 2">
                <div class="item thead type1">
                    <div class="tr">
                        <div class="td">订单信息</div>
                        <div class="td">开票金额</div>
                        <div class="td">发票操作</div>
                    </div>
                </div>
                <div class="item type1" v-for="(item, index) in list" :key="index">
                    <div class="top flex align_center">
                        <p class="code">订单号：{{item.order_code}}</p>
                    </div>
                    <div class="tr">
                        <div class="td">
                            <div class="info">
                                <router-link class="cover" :style="`background-image: url(${item.image});`" :to="`/shop/detail?id=${item.id}`"></router-link>
                                <div class="wrapper">
                                    <p class="name">
                                        <router-link :to="`/shop/detail?id=${item.id}`">{{item.name}}</router-link>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="td layout_flex_center">
                            <p class="price2">实际付款：RMB {{item.price}}<br/>含运费：RMB 0.00</p>
                        </div>
                        <div class="td layout_flex_center">
                            <div class="btn_group">
                                <div class="btn layout_flex_center" @click="isShowInvoiceList = true">申请发票</div>
                                <div class="btn layout_flex_center">订单详情</div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="item thead type2">
                    <div class="tr">
                        <div class="td">订单信息</div>
                        <div class="td">开票金额</div>
                        <div class="td">发票抬头</div>
                        <div class="td">发票类型</div>
                        <div class="td">发票日期</div>
                        <div class="td">开票进度</div>
                        <div class="td">发票操作</div>
                    </div>
                </div>
                <div class="item type2" v-for="(item, index) in list" :key="index">
                    <div class="top flex align_center">
                        <p class="code">订单号：{{item.order_code}}</p>
                    </div>
                    <div class="tr">
                        <div class="td">
                            <div class="info">
                                <router-link class="cover" :style="`background-image: url(${item.image});`" :to="`/shop/detail?id=${item.id}`"></router-link>
                                <div class="wrapper">
                                    <p class="name">
                                        <router-link :to="`/shop/detail?id=${item.id}`">{{item.name}}</router-link>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="td layout_flex_center">
                            <p class="price2">实际付款：RMB {{item.price}}<br/>含运费：RMB 0.00</p>
                        </div>
                        <div class="td layout_flex_center text_gray">个人-个人</div>
                        <div class="td layout_flex_center text_gray">普通发票-电子</div>
                        <div class="td layout_flex_center text_gray">2025-08-01</div>
                        <div class="td layout_flex_center flex_column">
                            <p class="text_gray" v-if="activeIndex == 0">已开票</p>
                            <p class="text_red" v-if="activeIndex == 1">申请中</p>
                            <p><a class="link_download" href="" download>下载到本地</a></p>
                        </div>
                        <div class="td layout_flex_center">
                            <div class="btn_group">
                                <div class="btn layout_flex_center type1" v-if="activeIndex == 0">查看发票</div>
                                <div class="btn layout_flex_center type1" v-if="activeIndex == 1">发票详情</div>
                                <div class="btn layout_flex_center">订单详情</div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <!-- 发票管理弹窗 -->
        <div class="popup invoice_popup" v-if="isShowInvoiceList">
            <div class="close position_100" @click="isShowInvoiceList = false"></div>
            <div class="in flex flex_column">
                <p class="title">发票管理</p>
                <div class="invoice_list">
                    <div class="item flex align_center" v-for="(item, index) in invoiceList" :key="index">
                        <div class="checkbox" :class="{active: item.isChecked}" @click="item.isChecked = !item.isChecked"></div>
                        <div class="info">
                            <p class="name">{{ item.title }}</p>
                            <p class="text">
                                <span v-if="item.type == 1">普通发票</span>
                                <span v-if="item.type == 2">专用发票</span>
                                <span> - </span>
                                <span v-if="item.title_type == 1">个人或事业单位</span>
                                <span v-if="item.title_type == 2">企业</span>
                                <span>抬头</span>
                            </p>
                        </div>
                        <div class="btn_group flex">
                            <div class="btn" @click="editInvoice(item)">编辑</div>
                            <div class="btn" :class="{disabled: item.is_default == 1}">默认抬头</div>
                        </div>
                    </div>
                </div>
                <div class="bottom flex align_center justify_between">
                    <div class="l flex">
                        <div class="check flex align_center" @click="checkAll">
                            <div class="checkbox" :class="{active: isCheckAll}"></div>
                            <div class="text">全选</div>
                        </div>
                        <div class="delete" :class="{disabled: isHideDelete}">删除抬头</div>
                    </div>
                    <div class="r">
                        <div class="btn" @click="createInvoice">新建抬头</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 发票详情 -->
        <div class="popup invoice_detail" v-if="isShowInvoiceDetail">
            <!-- <div class="close position_100" @click="isShowInvoiceDetail = false"></div> -->
            <div class="in flex flex_column">
                <div class="title" v-if="isEditInvoice">修改抬头</div>
                <div class="title" v-else>新建抬头</div>
                <div class="form">
                    <div class="item">
                        <p class="name">发票抬头 *</p>
                        <input type="text" placeholder="必填" ref="title" v-model="detail.title"/>
                    </div>
                    <div class="item">
                        <p class="name">抬头类型</p>
                        <div class="radio_group">
                            <label class="radio">
                                <input type="radio" value="1" v-model="detail.title_type"/>
                                <p class="text">个人或事业单位</p>
                            </label>
                            <label class="radio">
                                <input type="radio" value="2" v-model="detail.title_type"/>
                                <p class="text">企业</p>
                            </label>
                        </div>
                    </div>
                    <div class="item">
                        <p class="name">发票类型</p>
                        <MineSelect>
                            <template v-slot:value>{{ typeValue }}</template>
                            <MineOption v-for="(item, index) in type" :key="index"
                            :is-active="detail.type == item.value"
                            @click="detail.type = item.value">{{ item.text }}</MineOption>
                        </MineSelect>
                    </div>
                    <template v-if="detail.title_type == 2">
                        <div class="item">
                            <p class="name">税号 *</p>
                            <input type="text" placeholder="纳税人识别号或社会统一征信代码" ref="taxCode" v-model="detail.tax_code"/>
                        </div>
                        <div class="item">
                            <p class="name">开户银行 *</p>
                            <input type="text" placeholder="必填" ref="bankName" v-model="detail.bank_name"/>
                        </div>
                        <div class="item">
                            <p class="name">银行账户 *</p>
                            <input type="text" placeholder="必填" ref="bankCode" v-model="detail.bank_code"/>
                        </div>
                        <div class="item">
                            <p class="name">企业地址 *</p>
                            <input type="text" placeholder="必填" ref="address" v-model="detail.address"/>
                        </div>
                        <div class="item">
                            <p class="name">企业电话 *</p>
                            <input type="text" placeholder="必填" ref="phone" v-model="detail.phone"/>
                        </div>
                    </template>
                    <div class="item">
                        <p class="name">设为默认</p>
                        <div class="radio_group">
                            <label class="radio">
                                <input type="checkbox" value="1" v-model="detail.is_default"/>
                                <p class="text">设为默认后，将自动填充默认抬头及税号</p>
                            </label>
                        </div>
                    </div>
                    <div class="item justify_end">
                        <div class="btn" @click="isShowInvoiceDetail = false">取消</div>
                        <div class="btn">完成</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.invoice{
    .popup{
        &.invoice_popup{
            .in{
                height: 5.8rem;
            }
        }
        .in{
            padding: .3rem;
            .invoice_list{
                flex: 1;
                overflow-y: auto;
                .item{
                    gap: .2rem;
                    border-bottom: 1px solid #666;
                    padding: .1rem 0;
                    .info{
                        flex: 1;
                        cursor: pointer;
                    }
                    .name{
                        font-size: .16rem;
                    }
                    .text{
                        font-size: .12rem;
                        color: #999;
                    }
                }
            }
            .bottom{
                margin-top: .3rem;
                .l{
                    gap: .2rem;
                }
                .delete{
                    font-size: .16rem;
                    cursor: pointer;
                    &.disabled{
                        color: #666;
                        cursor: auto;
                    }
                }
                .check{
                    font-size: .12rem;
                    gap: .05rem;
                    cursor: pointer;
                    user-select: none;
                }
            }
            .checkbox{
                width: .12rem;
                height: .12rem;
                border: 1px solid var(--font_color);
                position: relative;
                cursor: pointer;
                &::after{
                    content: "";
                    width: 30%;
                    height: 60%;
                    border-bottom: 1px solid #000;
                    border-right: 1px solid #000;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -75%) rotate(45deg);
                    display: none;
                }
                &.active{
                    &::after{
                        display: block;
                    }
                }
            }
        }
    }
    .order_list{
        .item{
            &.type1{
                .tr{
                    .td{
                        &:nth-of-type(1){
                            width: 38%;
                        }
                        &:nth-of-type(2){
                            width: 42%;
                        }
                        &:nth-of-type(3){
                            width: 20%;
                        }
                    }
                }
            }
            &.type2{
                .tr{
                    .td{
                        &:nth-of-type(1){
                            width: 26%;
                        }
                        &:nth-of-type(2){
                            width: 19%;
                        }
                        &:nth-of-type(3),
                        &:nth-of-type(4),
                        &:nth-of-type(5),
                        &:nth-of-type(6),
                        &:nth-of-type(7){
                            width: 11%;
                        }
                    }
                }
            }
            .info{
                .cover{
                    margin-right: .1rem;
                }
                .wrapper{
                    padding: 0;
                    .name{
                        font-size: .12rem;
                    }
                }
            }
            .text_gray{
                color: #999;
            }
            .text_red{
                color: #ff0000;
            }
            .link_download{
                &:hover{
                    border-bottom: 1px solid var(--font_color);
                }
            }
        }
    }
}
</style>